var map = {
	"./AppBar": "9f03",
	"./AppBar.vue": "9f03",
	"./Footer": "3e61",
	"./Footer.vue": "3e61",
	"./GDPRConsent": "3bdf",
	"./GDPRConsent.vue": "3bdf",
	"./LocaleChanger": "7320",
	"./LocaleChanger.vue": "7320"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "462d";